import type { Question } from '@/data/fixtures';

export type QuizAnswer = string | number | number[];

/**
 * An answer as words, for the quiz's feedback panel ("Answer: Thylakoid
 * membrane") and its end-of-run "Review mistakes" list. Answers are stored as
 * the renderer stores them - an option index, indices for multiple select,
 * 'true' / 'false', or typed text - which mean nothing on their own.
 */
export function answerText(question: Question, answer: QuizAnswer): string {
  const option = (i: number) => question.options?.[i] ?? `Option ${i + 1}`;
  if (Array.isArray(answer)) {
    return answer.length === 0
      ? 'Nothing selected'
      : [...answer]
          .sort((a, b) => a - b)
          .map(option)
          .join(', ');
  }
  if (typeof answer === 'number') return option(answer);
  if (question.type === 'true-false') {
    return answer === 'true' ? 'True' : answer === 'false' ? 'False' : answer;
  }
  return answer;
}

/** The right answer, as words. */
export function correctAnswerText(question: Question): string {
  return answerText(question, question.correctAnswer);
}
